{
  /*
SPDX-FileCopyrightText: 2021 City of Turku

SPDX-License-Identifier: LGPL-2.1-or-later
*/
}

import type { CommonCustomizations } from 'lib-customizations/types'

import theme from './turku-theme'

const customizations: CommonCustomizations = {
  theme
}

export default customizations
